module.exports = __webpack_public_path__ + "img/astral_2.932f4d26.svg";